import React, { useEffect, useState } from 'react'
import { apiFunction } from '../../apiCall/function'

/**
 * Tells a candidate their application was rejected, and why.
 *
 * The admin panel stores the reason in user_details.last_rejection_reason when
 * an application is rejected (is_approved = 2), and form/application already
 * returns it — but no screen showed it, so a rejected candidate saw their form
 * unlocked again with no idea what to correct.
 *
 * Self-contained so the dashboard, the application form and the document step
 * can all show the same notice without each threading the data through.
 */
const RejectionNotice = () => {
    const [rejection, setRejection] = useState(null)

    useEffect(() => {
        let cancelled = false
        apiFunction('form/application', 'get', {}, true, 'body').then((res) => {
            if (cancelled || res?.code !== 1 || !res.data) return
            if (Number(res.data.is_approved) === 2) {
                setRejection({ reason: (res.data.last_rejection_reason || '').trim() })
            }
        })
        return () => { cancelled = true }
    }, [])

    if (!rejection) return null

    return (
        <div className='ui_reject' role='alert'>
            <i className='fa fa-times-circle' aria-hidden='true'></i>
            <div>
                <p className='ui_reject_title'>
                    Your application was rejected / आपका आवेदन अस्वीकृत किया गया है
                </p>
                {rejection.reason ? (
                    <p className='ui_reject_reason'>
                        <span>Reason / कारण:</span> {rejection.reason}
                    </p>
                ) : (
                    <p className='ui_reject_reason'>
                        No reason was recorded. Please contact BIPARD for details.
                    </p>
                )}
                <p className='ui_reject_next'>
                    Correct your application form and documents, then submit them again.
                    / कृपया आवेदन पत्र एवं दस्तावेज़ सुधार कर पुनः जमा करें।
                </p>
            </div>
        </div>
    )
}

export default RejectionNotice
